<template>
  <div class="v-nav-item"  :class="cssClassesNav">
    <div class="v-nav-item-title" @click="toggle()" >
      <slot></slot>
      <v-icon v-if="hasDropdown" icon="chevron-down" :ratio="0.4"></v-icon>
    </div>
    <transition name="toggle-dropdown">
      <slot v-show="hasDropdown" name="content"></slot>
    </transition>
  </div>
</template>

<script>
import VIcon from "../icon/Icon.vue";

export default {  
  name: "v-nav-item",
  components: {
    VIcon
  },
  props: {
    theme: { type: String, default: "light" },
    active: { type: Boolean, default: false }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    hasDropdown() {
      return !!this.$slots["content"];
    },
    routeName() {
      return this.$slots.default[0]?.componentOptions?.propsData?.to?.name;
    },
    isActive() {
      return this.$route?.matched.some(route => {
        route.name === this.routeName});

    },
    cssClassesNav() {
      let classes = [];
      classes.push("theme-" + this.theme);
      if(this.isOpen){
        classes.push("isOpen")
      }
      if(this.isActive  ){
        classes.push("active")
      }
      return classes;
    }
  },
  methods: {
    close(e) {
      if (this.hasDropdown && !this.$el.contains(e.target)) {
        this.isOpen = false;
      }
    },
    toggle() {
      this.isOpen = !this.isOpen;
      this.$parent.$emit("active", this.isOpen);
    }
  },
  watch: {
    $route(to, from) {
      this.isOpen = false;
    }
  },
  created() {
    this.$on("active", isOpen => {
      this.isOpen = isOpen;
      return true;
    });
  },
  mounted() {
    document.addEventListener("click", this.close);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.close);
  }
};
</script>

<style lang="scss">
@import "../../design/variables.scss";
$nav-content-width: 250px;

.v-nav-item {
  position: relative;
  display: flex;
  align-self: stretch;
  
  .v-nav-item-title {
    padding-top: 20px;
    padding-bottom: 21px;
    background: none;
    border: none;
    cursor: pointer;
    margin: 0 10px;
    display: flex;
    align-items: center;
    letter-spacing: 0.3px;
    outline: 0;
    user-select: none;
    border-top: 2px solid transparent;
    border-bottom: 2px solid transparent;

    .v-icon {
      margin-left: 5px;
      
    }

    > a {
      display: flex;
      align-items: center;
      strong {
        margin-left: 5px;
      }
      &.active {
        .v-icon {
          &.v-icon-chevron-down {
            transform: rotateX(180deg);
          }
        }
      }
    }
  }
  &:hover .v-nav-item-title{
    border-bottom: 2px solid #007bcd;
  }

  &.isOpen {
    .v-icon {
      &.v-icon-chevron-down {
        transform: rotateX(180deg);
      }
    }
  }

  &.theme-light {
    .v-nav-item-title {
      color: map-deep-get($colors, "foreground", "primary");
      // Dropdown
      &.isOpen {
        border-bottom-color: map-deep-get($colors, "foreground", "action");
      }
      // Link
      > a {
        color: map-deep-get($colors, "foreground", "primary");
      }
      .v-icon {
        color: map-deep-get($colors, "foreground", "action");
      }
    }
  }

  &.theme-dark {
    .v-nav-item-title {
      color: map-deep-get($colors, "foreground", "inverted");
      // Dropdown
      &.isOpen {
        border-bottom-color: map-deep-get($colors, "foreground", "inverted");
      }
      // Link
      > a {
        color: map-deep-get($colors, "foreground", "inverted");
      }
      .v-icon {
        color: map-deep-get($colors, "foreground", "inverted");
      }
    }
  }
}
@media screen and (max-width: $grid-tablet-breakpoint){
   .v-nav-item {
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    align-content: stretch;
    position: initial;
    border-bottom: 1px solid map-deep-get($colors, "ornament", "border");

    .v-nav-item-title {
      background: none;
      border: none;
      cursor: pointer;
      padding: 13px 0;

      .v-icon {
        position: relative;
        margin: 0 0 0 auto;
      }

      > a {
        display: flex;
        align-items: center;
        strong {
          margin-left: 5px;
        }
        &.active {
          .v-icon {
            &.v-icon-chevron-down {
              transform: rotate(270deg);
            }
          }
        }
         &.isOpen {
          .v-icon {
            &.v-icon-chevron-down {
              transform: rotate(270deg);
            }
          }
        }
      }
    }
    &:hover .v-nav-item-title{
      border-bottom: none;
    }

        &.isOpen {
          .v-icon {
            &.v-icon-chevron-down {
              transform: rotate(270deg);
            }
          }
        }
      .v-icon {
        &.v-icon-chevron-down {
          transform: rotate(270deg);
        }
      }

  }
}
</style>
